import * as React from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import RecipientsList from './components/recipientsList';
import { RootState } from 'redux/rootReducer';

import './index.scss';
import { ThunkDispatch } from 'redux-thunk';
import {
  MonthlyReportRecipient,
  MonthlyReportRecipientActions
} from 'redux/ducks/monthlyReportRecipients/types';
import {
  deleteRecipient as deleteRecipientAction,
  getRecipients as getRecipientsAction
} from 'redux/ducks/monthlyReportRecipients';
import { makeStyles } from '@material-ui/core/styles';
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;

type OwnProps = Record<string, never>;

type MonthlyReportsProps = StateProps & DispatchProps & OwnProps;

const useStyles = makeStyles({
  label: {
    fontWeight: 600,
    color: 'rgba(34, 34, 34, 0.85)'
  }
});

const MonthlyReports: React.FC<MonthlyReportsProps> = (props) => {
  const intl = useIntl();
  const classes = useStyles();
  const { recipients, deleteRecipient, getRecipients, monthlyReportTemplateType } = props;

  React.useEffect(() => {
    void getRecipients();
  }, []);

  return (
    <div className='MonthlyReports'>
      <span className={classes.label}>{intl.formatMessage({ id: 'recipientsMultiple' })}</span>
      <div id='recipient' className='control'>
        <RecipientsList
          recipients={recipients}
          monthlyReportTemplateType={monthlyReportTemplateType}
          onDelete={(id) => void deleteRecipient(id)}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  recipients: state.monthlyReportRecipients.recipients,
  monthlyReportTemplateType: state.settings.monthlyReportTemplateType
});

const mapDispatchToProps = (
  dispatch?: ThunkDispatch<RootState, void, MonthlyReportRecipientActions>
) => ({
  getRecipients: () => dispatch(getRecipientsAction()),
  deleteRecipient: (id: MonthlyReportRecipient['id']) => dispatch(deleteRecipientAction(id))
});

export default connect<StateProps, DispatchProps, OwnProps>(
  mapStateToProps,
  mapDispatchToProps
)(MonthlyReports);
